// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProfileCollectionTagList_wrapper__XnlTX"};